import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingQuoteTotals } from './types';

export function useBillingQuoteTotals(quoteId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TBillingQuoteTotals>(
    quoteId ? `commenda-billing/quotes/${quoteId}/totals` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { totals: data ?? null, error, isLoading, mutate };
}
